module.exports = __webpack_public_path__ + "img/emergency.b9a6a945.svg";